import { locations } from '../../asset/searchData'

export const getAreaListFromCity = (cityName = '') => {
  const cityData = locations.find(v => v.name === cityName)
  if (!cityData) {
    return []
  }
  const { area, route } = cityData
  return area.map(v => ({ ...v, route: `${route}/${v.route}` }))
}

export const currentCityList = [
  {
    name: 'Los Angeles',
    route: 'los-angeles'
  }
  // {
  //   name: 'Irving',
  //   route: 'irving'
  // }
  // {
  //   name: 'Houston',
  //   route: 'houston'
  // },
  // {
  //   name: 'Killeen',
  //   route: 'killeen'
  // },
  // {
  //   name: 'Corpus Christi',
  //   route: 'corpus-christi'
  // }
]
